<ng-container >
  <ion-header class="ion-align-items-center outer ion-no-border">
    <ion-toolbar>
      <div class="ion-justify-content-between ly-row ion-align-items-center">
        <div class="md-title-set ly-row ion-align-items-center">
          <ion-text class="ion-margin-start">
            <h3>{{ 'components.instagramAuth.titles.addHeader' | translate }}</h3>
          </ion-text>
        </div>
        <ion-button
          fill="clear"
          shape="round"
          class="button-icon ion-no-margin"
          color="medium"
          (click)="modal.dismiss()"
        >
          <ion-icon slot="icon-only" name="close"> </ion-icon>
        </ion-button>
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-grid>
    <ion-row>
      <ion-col>
        <img 
          style="width: 175px;"
          src="assets/img/authentication-graphic-2.png"
          >
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-text class="ion-margin-start">
    <h6 class="ion-text-center">
    {{ 'components.instagramAuth.messages.m4' | translate }}
    <a href="https://www.facebook.com/business/help/898752960195806" target="_blank">{{
      'components.instagramAuth.messages.m5' | translate }}</a>.
   </h6>
  </ion-text>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button color="danger" (click)="modal.dismiss()">{{ 'backText' | translate }}</ion-button>
      </ion-col>
      <ion-col>
        <ion-button color="tertiary" (click)="authenticate()">{{ 'authenticateText' | translate }}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
